export default __webpack_public_path__ + "static/media/motorola1.ee8e341f.png";